import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Logo, { PartnerLogo } from '@lt/components/components/Logo';
import { IPartnerLogo } from '@lt/components/components/Logo/types';
import {
  useGetWhitelabelLogo,
  useGetWhitelabelDomain,
  useGetIsWhitelabel,
  useGetBaseQueryParams,
} from '../../../../context/constructorContext';
import { createWidgetLink } from '../../../../utils/url/index';

export const StyledLogo = styled(Logo)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    height: 20px;
    width: auto;
  }
`;

export const WidgetLogo: FunctionComponent = () => {
  const partnerLogo = useGetWhitelabelLogo();
  const partnerDomain = useGetWhitelabelDomain();
  const isWhitelabel = useGetIsWhitelabel();

  const baseQueryParams = useGetBaseQueryParams();
  const link = createWidgetLink(partnerDomain, baseQueryParams);

  const partner: IPartnerLogo | undefined =
    isWhitelabel && partnerLogo && partnerDomain
      ? {
          isMobile: false,
          srcSet: partnerLogo.srcset,
          src: partnerLogo.src,
        }
      : undefined;

  if (partner) {
    return <PartnerLogo {...partner} />;
  }

  return <StyledLogo href={link} isBlack />;
};
